import { ListStateIconSuccess } from "source/components/framework/List/ListStateIconSuccess";
import { Tooltip } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const ApproveButton = (props: IAppButtonProps) => (
    <Tooltip title={Translations.Approve}>
        <AppButton
            variant="outlined"
            size="small"
            endIcon={<ListStateIconSuccess color="success" />}
            {...props}
        >
            {Translations.Approve}
        </AppButton>
    </Tooltip>
);
